module.exports = __webpack_public_path__ + "static/images/store-1.00217b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/store-1.png
// module id = HCwD
// module chunks = 8